import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Toolbar, Typography } from '@material-ui/core'
import clsx from 'clsx'
import ReaderDrawer from './drawer-container.component'
import { useReaderContext } from './context/reader-context'
import { ScormAppbar } from './ScormAppbar'
import { ScormDrawerContent } from './ScormDrawerContent'

const drawerWidth = 300

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    backgroundColor: theme.palette.background.paper,
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  toolbar: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  menuButton: {},
  hide: {
    display: 'none',
  },
  main: {
    width: '100%',
  },
  mainShift: {
    width: `calc(100% - ${drawerWidth}px)`,
  },
  header: {
    fontSize: 30,
    fontWeight: 300,
  },
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  iframe: {
    width: 1060,
    height: `calc(100vh - ${62}px)`,
  },
  iframeShift: {},
}))

function bindEvent(element, eventName, eventHandler) {
  if (element.addEventListener) {
    element.addEventListener(eventName, eventHandler, false)
  } else if (element.attachEvent) {
    element.attachEvent('on' + eventName, eventHandler)
  }
}
function unBindEvent(element, eventName, eventHandler) {
  if (element.removeEventListener) {
    element.removeEventListener(eventName, eventHandler)
  } else if (element.detachEvent) {
    element.detachEvent('on' + eventName, eventHandler)
  }
}

export const Scorm12Reader = () => {
  const classes = useStyles()
  const {
    iRef,
    scorm: { url, folder },
    info: { pages, availableActivities, currentActivity, title },
    drawer: { open },
    actions: { setCurrentActivity },
  } = useReaderContext()

  // const { apiConnected, learnerName, completionStatus, setStatus, setScore } =
  //   useScorm()

  const [, setHasLoaded] = React.useState(false)

  const handleLoad = () => {
    setHasLoaded(true)
  }

  // const {
  //   ui: { SHOW_ANSWERS_BUTTON, hasNext, hasPrev },
  //   actions: {
  //     handleLoad,
  //     handleToggleDrawer,
  //     handleNext,
  //     handlePrev,
  //     handleClickExercise,
  //     showAnswers,
  //     showNextAnswer,
  //     hideLastAnswer,
  //   },
  //   hasLoaded,
  //   calculatedMargin,
  // } = useEpub3State()
  // console.log('scorm pages', pages)

  const handleClickPage = (href) => {
    setCurrentActivity(href)
    let payload = JSON.stringify({
      action: 'change page',
      src: folder + href,
      // src: folder + 'interaction/sk/engineBootstrap/engine_bootstrap.html',
      // src: folder + 'hotspots/19417/interaction/sk/cat/static-dialogue.html',
    })

    // {action: "change page", src:"asdasdas.html"}
    console.log('sending message to iframe', payload)
    iRef.current.contentWindow.postMessage(payload, '*')
  }

  const handleMessage = (obj) => {
    // console.log(
    //   '**************************************handleMessage***************************************************',
    //   obj
    // )
    // if (typeof obj.data === 'string' && obj.data !== 'recaptcha-setup') {
    //   let message = JSON.parse(obj.data)
    //   console.log('PARSED MESSAGE', message)
    // }
  }

  React.useEffect(() => {
    bindEvent(window, 'message', handleMessage)
    return () => unBindEvent(window, 'message', handleMessage)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <div className={classes.root}>
      <ScormAppbar
        pages={pages}
        // onOpen={handleToggleDrawer}
        // onNext={handleNext}
        // onPrev={handlePrev}
        // hasNext={hasNext}
        // hasPrev={hasPrev}
        // onShowAnswers={showAnswers}
        // onShowNextAnswer={showNextAnswer}
        // onHideLastAnswer={hideLastAnswer}
        // enableShowAnswers={SHOW_ANSWERS_BUTTON}
      />
      {pages?.length ? (
        <ReaderDrawer>
          <ScormDrawerContent onExerciseClick={handleClickPage} />
        </ReaderDrawer>
      ) : null}

      <main
        className={clsx(classes.main, {
          [classes.mainShift]: open,
        })}
      >
        <Toolbar />
        {/* {!hasLoaded && availableActivities?.length > 0 ? (
          <LinearProgress style={{ width: '1920px' }} />
        ) : null} */}
        {availableActivities?.length === 0 ? (
          <Typography
            variant="h1"
            color="primary"
            style={{ textAlign: 'center', padding: '150px 0' }}
          >
            No activities
          </Typography>
        ) : null}
        {JSON.stringify(currentActivity, null, 2)}
        {/* {currentActivity ? ( */}
        <div>{url}</div>
        {/* <div>{folder}</div> */}
        {/* <p>SCORM API Connected: {apiConnected ? 'Yes' : 'No'}</p>
        <p>Welcome, {learnerName}!</p>
        <p>Your course status is currently: {completionStatus}</p>
        <button onClick={() => setStatus('completed')}>
          Mark me complete!
        </button>
        <button
          onClick={() =>
            setScore({
              value: 100,
              min: 0,
              max: 100,
              status: 'passed',
            })
          }
        >
          Score 100%
        </button> */}
        <iframe
          ref={iRef}
          className={clsx(classes.iframe, {
            [classes.iframeShift]: open,
          })}
          src={url}
          // src={folder + 'shared/launchpage.html'}
          title={title}
          frameBorder="0"
          onLoad={handleLoad}
        ></iframe>
        {/* <ReaderFrame
          variant="scorm"
          ref={iRef}
          loaded={hasLoaded}
          frameSrc={url}
          // frameSrc={!currentActivity ? url : `/test/${currentActivity}`}
          onLoad={handleLoad}
        /> */}
        {/* ) : null} */}
      </main>
    </div>
  )
}
